import { render, staticRenderFns } from "./BaseSheet.vue?vue&type=template&id=687f926c&scoped=true"
import script from "./BaseSheet.vue?vue&type=script&lang=js"
export * from "./BaseSheet.vue?vue&type=script&lang=js"
import style0 from "./BaseSheet.vue?vue&type=style&index=0&id=687f926c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f926c",
  null
  
)

export default component.exports